/**
 * TanStack Query hooks for `magento-connector`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	magentoConnectorQueryKeys,
	type CreateMagentoConnectorBody,
	type ListMagentoConnectorResponse,
	type MagentoConnectorRow,
} from "./api";

export function useMagentoConnectorList(): UseQueryResult<ListMagentoConnectorResponse, Error> {
	return useQuery({
		queryKey: magentoConnectorQueryKeys.list(),
		queryFn: list,
	});
}

export function useMagentoConnectorCreate(): UseMutationResult<MagentoConnectorRow, Error, CreateMagentoConnectorBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: magentoConnectorQueryKeys.all });
		},
	});
}

export function useMagentoConnectorDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: magentoConnectorQueryKeys.all });
		},
	});
}
